import React from 'react';

interface ModalSectionProps {
  title?: string;
  children: React.ReactNode;
  className?: string;
  spacing?: 'sm' | 'md' | 'lg';
}

const spacingClasses = {
  sm: 'space-y-3',
  md: 'space-y-4',
  lg: 'space-y-6'
};

export const ModalSection: React.FC<ModalSectionProps> = ({ 
  title, 
  children, 
  className = '',
  spacing = 'md'
}) => {
  return (
    <div className={`${spacingClasses[spacing]} ${className}`}>
      {title && (
        <h3 className="text-lg font-medium text-gray-900 dark:text-white">
          {title}
        </h3>
      )}
      {children}
    </div>
  );
};